// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--qPj5z";
export var customerLogos = "styles-module--customerLogos--3tmwD";
export var eyebrow = "styles-module--eyebrow--yeOb7";
export var logos = "styles-module--logos--zXWs7";
export var logo = "styles-module--logo--tGmd4";